import {
  reactSelectInlineError,
  reactSelectErrorStyles,
  SelectContainer,
  Icon,
  getTranslatedText,
  BackgroundIcon
} from '@nile/components';
import { GET_CLIENTS } from '@nile/graphql';
import { AccountClient } from '@nile/graphql';
import {
  DropdownIndicator,
  formatGroupLabel,
  IndicatorSeparator,
  DropdownArrow
} from '@nile/mangifera/src/Pebbles/select';
import { Avatar, Badge, Spinner } from '@superops/ui-design-system';
import React, { useEffect, useState } from 'react';
import { useLazyQuery } from '@apollo/client';
import Select from 'react-select';
import envConfig from '@nile/home/src/Config/env';
import { injectIntl } from 'react-intl';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import { cloneDeep } from 'lodash';
import { SVGIcon } from '@superops/super-icons';

const SelectWrapper = styled.div`
  .container > div {
    border: none !important;
  }
  .Superops-Avatar__Image {
    height: 20px;
    width: 20px;
    background: #d86bde !important;
  }
  .Superops-Avatar--hasImage {
    background: #d86bde !important;
  }
  .container {
    margin: ${(props) =>
      props?.noMargin
        ? '0px'
        : props?.fullWidth
        ? '0px 0px 0px 10px'
        : '0px 10px'};
    width: 100%;
  }
`;

function ClientSelect(props) {
  const {
    intl,
    updateField,
    property,
    value,
    selectedValue,
    defaultValue,
    errors,
    icon,
    fetchBefore,
    conditions,
    isClearable,
    showLabel,
    disabled,
    clientsToFilter,
    hideIcon,
    prePopulateOptions = null,
    query,
    fullWidth,
    containerClassName,
    isMulti = false,
    skipFilter = false,
    menuStyleProps = {},
    menuListStyleProps = {},
    noMargin
  } = props;
  const [options, setoptions] = useState([]);
  const [alloptions, setAlloptions] = useState([]);
  const [error, setErrors] = useState('');
  const listInfoData = {
    sort: {
      attribute: 'name',
      order: 'ASC'
    }
  };

  const queryData = query || GET_CLIENTS;

  const [getClients, { called, loading, data }] = useLazyQuery(queryData, {
    client: AccountClient,
    fetchPolicy: 'cache-and-network',
    variables: {
      listInfo: conditions
        ? { ...listInfoData, condition: conditions }
        : { ...listInfoData }
    }
  });

  useEffect(() => {
    if (fetchBefore && !prePopulateOptions) {
      getClients();
    }
  }, [fetchBefore]);

  useEffect(() => {
    if (data?.getClientList || prePopulateOptions) {
      let clients =
        prePopulateOptions ||
        JSON.parse(JSON.stringify(data?.getClientList?.clients));
      for (let i = 0; i < clients.length; i++) {
        clients[i].label = clients[i].name;
        clients[i].value = clients[i].name;
      }
      setAlloptions(clients);
      if (clientsToFilter) {
        clients = clients.filter((el) => {
          return !clientsToFilter?.some((cl) => cl.accountId === el.accountId);
        });
      }
      setoptions(clients);
    }
  }, [data, prePopulateOptions]);

  useEffect(() => {
    let clients = cloneDeep(alloptions);
    if (clientsToFilter) {
      clients = clients.filter((el) => {
        return !clientsToFilter?.some((cl) => cl.accountId === el.accountId);
      });
    }
    setoptions(clients);
  }, [clientsToFilter, selectedValue, alloptions]);

  useEffect(() => {
    setErrors(props.errors);
  }, [props.errors]);

  const onChangeField = (field) => {
    let obj = null;
    if (field) {
      if (isMulti) {
        obj = field;
      } else {
        obj = {};
        obj[property] = field[property];
        if (field?.name) {
          obj.name = field.name;
        }
      }
    }
    updateField(value, obj);
  };

  useEffect(() => {
    setErrors(props.errors);
  }, [props.errors]);

  const constructDropDownError = () => {
    if (errors) {
      return reactSelectInlineError(errors);
    }
    return null;
  };

  const filterOptions = () => {
    if (skipFilter) {
      if (isMulti) {
        if (
          !selectedValue ||
          (Array.isArray(selectedValue) && selectedValue?.length === 0)
        ) {
          return [];
        }
        const selectedValueForDropDown = selectedValue?.map((el) => ({
          ...el,
          label: el?.name,
          value: el?.accountId
        }));
        return selectedValueForDropDown;
      }
      return selectedValue
        ? {
            ...selectedValue,
            label: selectedValue?.name,
            value: selectedValue?.accountId
          }
        : null;
    }
    if (isMulti)
      return alloptions.filter((obj1) =>
        (selectedValue || []).some(
          (obj2) => obj2?.accountId === obj1?.accountId
        )
      );
    return (
      alloptions.find((el) => el?.accountId === selectedValue?.accountId) ||
      null
    );
  };

  const selectedOption = filterOptions();

  return (
    <SelectWrapper
      fullWidth={fullWidth}
      className={fullWidth ? 'w100' : ''}
      noMargin={noMargin}
    >
      {showLabel && (
        <div className="Polaris-Label">
          <label
            id="clientSelect"
            htmlFor="clientSelect"
            className="Polaris-Label__Text"
          >
            <FormattedMessage id="app.clientSelect.label" />
          </label>
        </div>
      )}
      <div className="fx center select-container">
        {!hideIcon &&
          (icon ? (
            <div className="fx center" style={{ opacity: '0.6' }}>
              <SVGIcon name="ClientLogo" />
            </div>
          ) : (
            <Badge status="warning" radial size="small">
              <div className="opacity6 flex">
                <SVGIcon name="ClientLogo" />
              </div>
            </Badge>
          ))}

        <div className={containerClassName || 'container'}>
          {fetchBefore && loading && !data ? (
            <Spinner
              accessibilityLabel="Small spinner example"
              size="small"
              color="inkLightest"
            />
          ) : (
            <>
              <Select
                className={``}
                key={selectedOption?.accountId}
                onMenuOpen={() => {
                  if (!fetchBefore) getClients();
                }}
                classNamePrefix="value_selector"
                formatGroupLabel={formatGroupLabel}
                defaultValue={defaultValue}
                value={selectedOption}
                components={{ IndicatorSeparator, DropdownArrow }}
                title={getTranslatedText(intl, 'ticket.new.client')}
                onChange={onChangeField}
                options={options}
                placeholder={getTranslatedText(intl, 'ticket.new.pl.client')}
                menuPortalTarget={document.body}
                menuPlacement="auto"
                isMulti={isMulti}
                closeMenuOnScroll={(e) => {
                  return (
                    e.target &&
                    e.target.classList &&
                    !(e.target.classList.value.indexOf('menu-list') > -1)
                  );
                }}
                name="valueselector"
                styles={
                  props?.errors
                    ? {
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        menu: (base) => ({
                          ...base,
                          ...menuStyleProps,
                          zIndex: 9999
                        }),
                        menuList: (base) => ({
                          ...base,
                          ...menuListStyleProps
                        }),
                        ...reactSelectErrorStyles
                      }
                    : {
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        menuList: (base) => ({
                          ...base,
                          ...menuListStyleProps
                        }),
                        menu: (base) => ({ ...base, zIndex: 9999 })
                      }
                }
                noOptionsMessage={() => {
                  return loading ? 'Loading...' : 'No options';
                }}
                isClearable={isClearable}
                isDisabled={disabled}
              />
              {constructDropDownError()}
            </>
          )}
        </div>
      </div>
    </SelectWrapper>
  );
}

export default injectIntl(ClientSelect);
